var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box_img"},[_c('form-header',{attrs:{"name":'获取方法：',"label":'上传图片后复制网络地址'}}),_c('uploadFile',{attrs:{"type":"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }